import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=0a956ac8&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=0a956ac8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a956ac8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a956ac8')) {
      api.createRecord('0a956ac8', component.options)
    } else {
      api.reload('0a956ac8', component.options)
    }
    module.hot.accept("./ImageView.vue?vue&type=template&id=0a956ac8&scoped=true", function () {
      api.rerender('0a956ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/com/ImageView.vue"
export default component.exports